import React from "react";
import { Button, Card, Table } from "antd";
import { useEffect } from "react";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import SoftBox from "StyleFeatures/SoftBox";
import Footer from "Common/Footer";
import useComplaints from "Hooks/AdminHooks/useComplaints";
import { useNavigate } from "react-router-dom";

function Complaints() {
  const {
    columns,
    handleDownloadReport,
    handleDepartmentChange,
    loading,
    departments,
    selectedDepartment,
    filteredData,
  } = useComplaints();
  const navigate = useNavigate();
  useEffect(() => {}, [departments]);

  return (
    <DashboardLayout>
      <div className="wrapper d-flex flex-column min-vh-100 bg-light">
        <DashboardNavbar />
        <div className="body flex-grow-1 px-3">
          <Card 
          title="Complaints"
           className="card-professional"
                extra={
                      <Button className="btn-back" onClick={() => navigate("/dashboard")}>
                         Back
                 </Button>
               }
           >
            <div style={{ display: "flex", justifyContent: "flex-end" }}>
              <SoftBox color="text" style={{ marginRight: "20px" }}>
                <div style={{ display: "inline-block" }}>
                  <Button className="btn-primary" onClick={handleDownloadReport}>
                    <i className="fa fa-download" aria-hidden="true"></i>&nbsp;Download Complaint
                    Reports
                  </Button>
                </div>
              </SoftBox>
              <div className="mb-3" style={{ display: "inline-block" }}>
                <select
                  className="form-select form-select-sm"
                  value={selectedDepartment || "All"}
                  onChange={handleDepartmentChange}
                >
                  <option value="All">All Departments</option>
                  {departments.map((dept) => (
                    <option key={dept.id} value={String(dept.id)}>
                      {dept.name}
                    </option>
                  ))}
                </select>
              </div>
            </div>
            <div className="row mb-3">
              <Table
                className="custom-table"
                bordered
                loading={loading}
                dataSource={filteredData}
                columns={columns}
                pagination={{ pageSize: 10 }}
              />
            </div>
          </Card>
          <Footer />
        </div>
      </div>
    </DashboardLayout>
  );
}

export default Complaints;
